/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Empty,
  Tabs,
  Row,
  Col,
  Spin,
  Card,
} from 'antd';
import { checkToken } from 'api/utils';
import {
  getLiquidacionesConfiguraciones,
} from 'api/nominas/liquidaciones/liquidacionesConfiguraciones';
import { getModelPermission } from 'utils/permission';
import LiquidacionesConfiguracionesFiniquito, { liquidacionConfiguracionFiniquitoPermission } from './LiquidacionesConfiguracionesFiniquito';
import LiquidacionesConfiguracionesIndemnizaciones, { liquidacionConfiguracionIndemnizacionPermission } from './LiquidacionesConfiguracionesIndemnizaciones';
import LiquidacionesConfiguracionesLaudos, { liquidacionConfiguracionLaudoPermission } from './LiquidacionesConfiguracionesLaudos';
import LiquidacionesConfiguracionesDescuentos, { liquidacionConfiguracionDescuentoPermission } from './LiquidacionesConfiguracionesDescuentos';
import LiquidacionesConfiguracionesIncidencias, { liquidacionConfiguracionIncidenciaPermission } from './LiquidacionesConfiguracionesIncidencias';
import LiquidacionesConfiguracionesDeducciones, { liquidacionConfiguracionDeduccionPermission } from './LiquidacionesConfiguracionesDeducciones';

export const liquidacionConfiguracionPermission = {
  permissionModel: 'liquidacionconfiguracion',
  catalogsModels: [],
  tabsModels: [],
};

// El TAB Deducciones se ocultaba a petición de negocio (ver
// 172.LIQUIDACIONES.ADECUACIONES.xlsx) porque el cálculo de la Deducción de ISR
// siempre daba $0.00 (ver calcular_Deduccion() en
// nominas/serializers/liquidaciones_empleados.py) -- ya corregido. Se reactiva para
// poder Autorizar/Cancelar/Reactivar la Deducción de ISR desde esta pantalla.
const OCULTAR_TAB_DEDUCCIONES = false;

const { TabPane } = Tabs;

const LiquidacionesConfiguraciones = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [currentTabKey, setCurrentTabKey] = useState('finiquito');

  const getPermissionFiniquito = getModelPermission(
    liquidacionConfiguracionFiniquitoPermission.permissionModel,
    liquidacionConfiguracionFiniquitoPermission.catalogsModels,
    liquidacionConfiguracionFiniquitoPermission.tabsModels,
    false,
  );

  const getPermissionIndemnizaciones = getModelPermission(
    liquidacionConfiguracionIndemnizacionPermission.permissionModel,
    liquidacionConfiguracionIndemnizacionPermission.catalogsModels,
    liquidacionConfiguracionIndemnizacionPermission.tabsModels,
    false,
  );

  const getPermissionLaudos = getModelPermission(
    liquidacionConfiguracionLaudoPermission.permissionModel,
    liquidacionConfiguracionLaudoPermission.catalogsModels,
    liquidacionConfiguracionLaudoPermission.tabsModels,
    false,
  );

  const getPermissionDescuentos = getModelPermission(
    liquidacionConfiguracionDescuentoPermission.permissionModel,
    liquidacionConfiguracionDescuentoPermission.catalogsModels,
    liquidacionConfiguracionDescuentoPermission.tabsModels,
    false,
  );

  const getPermissionIncidencias = getModelPermission(
    liquidacionConfiguracionIncidenciaPermission.permissionModel,
    liquidacionConfiguracionIncidenciaPermission.catalogsModels,
    liquidacionConfiguracionIncidenciaPermission.tabsModels,
    false,
  );

  const getPermissionDeducciones = getModelPermission(
    liquidacionConfiguracionDeduccionPermission.permissionModel,
    liquidacionConfiguracionDeduccionPermission.catalogsModels,
    liquidacionConfiguracionDeduccionPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getLiquidacionesConfiguraciones(),
      ]);
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          title="Editar Configuración de Liquidación"
          bordered={false}
        >
          { data?.length ? (
            permission?.change && permission?.view ? (
              <Tabs
                type="card"
                activeKey={currentTabKey}
                onChange={setCurrentTabKey}
              >
                <TabPane
                  tab={(
                    <span>
                      Finiquito
                    </span>
                  )}
                  key="finiquito"
                  forceRender
                >
                  <LiquidacionesConfiguracionesFiniquito
                    permission={getPermissionFiniquito}
                    liquidacionConfiguracion={data[0]}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      Indemnización
                    </span>
                  )}
                  key="indemnizacion"
                  forceRender
                >
                  <LiquidacionesConfiguracionesIndemnizaciones
                    permission={getPermissionIndemnizaciones}
                    liquidacionConfiguracion={data[0]}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      Laudo
                    </span>
                  )}
                  key="laudo"
                  forceRender
                >
                  <LiquidacionesConfiguracionesLaudos
                    permission={getPermissionLaudos}
                    liquidacionConfiguracion={data[0]}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      Descuentos
                    </span>
                  )}
                  key="descuentos"
                  forceRender
                >
                  <LiquidacionesConfiguracionesDescuentos
                    permission={getPermissionDescuentos}
                    liquidacionConfiguracion={data[0]}
                  />
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      Incidencias
                    </span>
                  )}
                  key="incidencias"
                  forceRender
                >
                  <LiquidacionesConfiguracionesIncidencias
                    permission={getPermissionIncidencias}
                    liquidacionConfiguracion={data[0]}
                  />
                </TabPane>
                {!OCULTAR_TAB_DEDUCCIONES && (
                  <TabPane
                    tab={(
                      <span>
                        Deducciones
                      </span>
                    )}
                    key="deducciones"
                    forceRender
                  >
                    <LiquidacionesConfiguracionesDeducciones
                      permission={getPermissionDeducciones}
                      liquidacionConfiguracion={data[0]}
                    />
                  </TabPane>
                )}
              </Tabs>
            ) : (
              <Row align="middle" style={{ height: '100%' }}>
                <Col span={24}>
                  <Empty
                    description={
                      <p>Hacen falta permisos en los catálogos relacionados a este módulo.</p>
                    }
                  />
                </Col>
              </Row>
            )
          ) : (
            <Row align="middle" style={{ height: '100%' }}>
              <Col span={24}>
                <Empty
                  description={
                    <p>Necesitas crear una configuración de liquidaciones primero.</p>
                  }
                />
              </Col>
            </Row>
          )}
        </Card>
      </Spin>
    </Row>
  );
};

export default LiquidacionesConfiguraciones;
